import InputSelect from "./InputSelect";
import InputSelectSearchable from "./InputSelectSearchable";

const maxOptionsToEnableSearch = 20;

const InputSelectWrapper = (props) => {
	const enableSearch =
		props.useHyperionTheme && props.options?.length > maxOptionsToEnableSearch;

	return enableSearch ? (
		<InputSelectSearchable {...props} />
	) : (
		<InputSelect {...props} />
	);
};

export default InputSelectWrapper;
